import  React, { useState, useEffect, useRef} from 'react';
import { API } from 'aws-amplify';
import './FollowTheBeatModule10.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PopUp from '../Popup/logoutPopup';
import LottieAnimation from '../components/Lottie/LottieAnimation';
import left from './left_hand.svg'
import right from './right_hand.svg'
import loading from "./../loading-gif-png-5.gif"

  const FollowTheBeatModule10 = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const dispatch = useDispatch();
    const lottieRef = useRef()
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    let bird = generateImageUrl('images/Module5Images/Bird+Closing+still.gif')
    let alien = generateImageUrl('images/Module10Images/FTB_Alien.png')
    let coinBar = generateImageUrl('images/Images/Coin+Counter.png')
    let coin = generateImageUrl('images/Images/Coin_Empty.png')

    let [playInstructions, setPlayInstructions] = useState(false);
    let [monkeyStatemonkeyState, setMonkeyState] = useState(bird);
    let [playSong, setPlaySong] = useState(false);
    let [song, setSong] = useState(props.song);
    let [playAwesomeJob, setPlayAwesomeJob] = useState(false);

    let [coinAnimationState, setCoinAnimationState] = useState("");
    let [showCoin, setShowCoin] = useState(false);

    let [CountingGif, setCountingGif] = useState(props.count);
    let [counting, setCounting] = useState(false);

    let [awesomeJobAudio, setAwesomeJobAudio] = useState(props.awesomeJob);
    let [awesomeJobGIF, setAwesomeJobGIF] = useState(props.awesomeJobGIF);
    let [showAnimal, setShowAnimal] = useState(false);
    let [audioReady, setAudioReady] = useState(false);
    let [displayVoice, setDisplayVoice] = useState(false);
    let [animalVoice, setAnimalVoice] = useState('');
    const [score, setScore] = useState(0);

    const [isOpen, setIsOpen] = useState(false);
    const [tutorial, setTutorial] = useState(props.tutorial1);

    let [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'))

    // Music audio refs/state
    const musicAudioRef = useRef(null);
    const expectedMusicSrcRef = useRef('');
    const musicEndActionRef = useRef(null);
    const musicOnPlayActionRef = useRef(null);
    const [musicSrc, setMusicSrc] = useState('');
    const [musicShouldPlay, setMusicShouldPlay] = useState(false);

     // Starts the application
     useEffect(() => {
      const audi = new Audio();
      audi.src = props.awesomeJob
      const img = new Image();
      img.src = props.awesomeJobGIF
      controllerStart();
    }, []);

    const togglePopup = () => {
      setIsOpen(!isOpen);
    }

    // Helper to programmatically play music audio
    const playMusicAudio = async (src, onEndedAction = null, onPlayAction = null, restartIfSame = true) => {
      if (src && typeof src.then === 'function') src = await src;
      const el = musicAudioRef.current;
      const currentSrc = el ? (el.currentSrc || el.src) : '';
      const same = !!currentSrc && currentSrc.includes(src);
      expectedMusicSrcRef.current = src;
      musicEndActionRef.current = onEndedAction;
      musicOnPlayActionRef.current = onPlayAction;
      if (el && same) {
        if (!restartIfSame) return;
        try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
      } else {
        setMusicSrc(src);
        setMusicShouldPlay(true);
      }
    };

    const timing = [
      {
          timestamp: 0.0
      },
      {
          timestamp: 5.40
      },
      {
          timestamp: 6.98
      },
      {
          timestamp: 8.42
      },
      {
          timestamp: 10.0
      },

      {
          timestamp: 11.6
      },
      {
          timestamp: 13.18
      },
      {
          timestamp: 14.75
      },
      {
          timestamp: 16.25
      },

      {
          timestamp: 17.85
      },
      {
          timestamp: 19.45
      },
      {
          timestamp: 21.05
      },
      {
          timestamp: 22.82
      },

      {
        timestamp: 24
      },
      {
        timestamp: 25.60
      },
      {
        timestamp: 27.18
      },
      {
        timestamp: 28.75
      },

      {
        timestamp: 30.25
      },
      {
        timestamp: 31.83
      },
      {
        timestamp: 33.43
      },
      {
        timestamp: 35.20
      },

      {
        timestamp: 36.75
      },
      {
        timestamp: 38.08
      },
      {
        timestamp: 39.68
      },
      {
        timestamp: 41.42
      },

      {
        timestamp: 42.42
      },
      {
        timestamp: 44.3
      },
      {
        timestamp: 45.90
      },
      {
        timestamp: 47.4
      },

      {
        timestamp: 48.9
      },
      {
        timestamp: 50.68
      },
      {
        timestamp: 52.28
      },
      {
        timestamp: 53.5
      },

      {
        timestamp: 55.54
      },
      {
        timestamp: 56.92
      },
      {
        timestamp: 58.52
      },
      {
        timestamp: 60.0
      },

      {
        timestamp: 61.50
      },
      {
        timestamp: 63.00
      },
      {
        timestamp: 64.5
      },
      {
        timestamp: 66.0
      },
        
    ]

    
    const [context, setContext] = useState({
        circleCount: 1,
        timingCount: 0,
        activateClickDiv: false,
        clickedOnce: false,
        showCircle1: false, 
        showCircle2: false,
        showCircle3: false,
        showCircle4: false,
        timerId: 0,
        secondTimerId: 0,
        startedTutorial: false,
        finishedTutorial: false,
        startedTutorial2: false,
        finishedTutorial2: false,
    })

    // Play tutorial (music channel) when startedTutorial is set
    useEffect(() => {
      if (!context.startedTutorial) return;
      playMusicAudio(
        tutorial,
        () => {
          document.getElementsByClassName('circleCometDiv')[0].style.display = 'none'
          context.secondTimerId = setTimeout(() => {
            context.activateClickDiv = true;
            context.clickedOnce = false;
            setContext({ ...context});
          }, 1000);
          if (props.unit4){
            if(tutorial !== props.tutorial1_2){
              document.getElementById('rightHand').style.display = 'block';
            }
            else{
              document.getElementById('leftHand').style.display = 'block';
            }
          }
          document.getElementsByClassName('circleCometDiv')[0].style.display = 'block'
          context.startedTutorial = false;
          setContext({ ...context });
        }
      );
    }, [context.startedTutorial, tutorial]);

    // Play tutorial2 (music channel) when startedTutorial2 is set
    useEffect(() => {
      if (!context.startedTutorial2) return;
      playMusicAudio(
        props.tutorial2,
        () => {
          document.getElementsByClassName('circleCometDiv')[0].style.display = 'none';
          document.getElementsByClassName('circleCometDiv')[1].style.display = 'none';
          document.getElementsByClassName('circleCometDiv')[2].style.display = 'none';
          document.getElementsByClassName('circleCometDiv')[3].style.display = 'none';
          setPlaySong(true);
        }
      );
    }, [context.startedTutorial2, props.tutorial2]);

    // Play main song (music channel) when playSong is toggled
    useEffect(() => {
      if (!playSong) return;
      playMusicAudio(
        song,
        () => {
          setPlaySong(false)
          setCounting(false)
          if(context.finishedTutorial){
            if(props.unit3 || props.unit4){
              document.getElementsByClassName('circleCometDiv')[0].style.display = 'none';
              document.getElementById('rightHand').style.display = 'none';
              document.getElementById('leftHand').style.display = 'none';
            }
            setAnimalVoice(awesomeJobAudio);
            setMonkeyState(awesomeJobGIF)
            setShowAnimal(true);
            setPlayAwesomeJob(true)
          }
          else{
            togglePopup()
            document.getElementsByClassName('circleCometDiv')[0].style.display = 'none';
            document.getElementsByClassName('circleCometDiv')[1].style.display = 'none';
            document.getElementsByClassName('circleCometDiv')[2].style.display = 'none';
            document.getElementsByClassName('circleCometDiv')[3].style.display = 'none';
            context.finishedTutorial = true;
            setContext({ ...context})
          }
        },
        () => {
          context.finishedTutorial ? StartFTB() : ftbTutorial()
        }
      );
    }, [playSong, song]);

const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 10 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

    async function  StartFTB(){ 
      let count = 0
      let round = 1;
      if(props.unit3 || props.unit4){
        document.getElementById('tappingBird').style.display='block'
        sleep(100).then(() => {
          document.getElementsByClassName('animateBirdFollow')[0].style.display='none';
        })
      }
      for (let i = 1; i < timing.length; i++){
        await new Promise(resolve => setTimeout(resolve, ((timing[i].timestamp - timing[i-1].timestamp) * 1000)))
        setCounting(false);
        setCountingGif(null)
        await sleep(1);
        if(count===0){
          document.getElementsByClassName('circleCometDiv')[3].style.display = 'none';
        }
        else{
          if(count===1){
            if(props.unit4){
              document.getElementById('rightHand').style.display =
              'none';
              document.getElementById('leftHand').style.display =
              'none';
            }
            context.activateClickDiv = false;
            setContext({ ...context})
          }
          document.getElementsByClassName('circleCometDiv')[count-1].style.display = 'none';
        }
        document.getElementsByClassName('circleCometDiv')[count].style.display = 'block';
        if(count === 0){
          if((round % 2) !== 0 && props.unit4){
            document.getElementById('rightHand').style.display =
            'block';
          }
          else if ((round % 2) === 0 && props.unit4){
            document.getElementById('leftHand').style.display =
            'block';
          }
          setTimeout(() => {
            if(!props.unit3 && !props.unit4) {
              setCountingGif(props.count)
              setCounting(true);
            }
            context.activateClickDiv = true;
            setContext({ ...context});
          }, 900);
        }
        else{
          if(!props.unit3 && !props.unit4) {
            setCountingGif(props.count)
            setCounting(true);
          }
          else{
            setTimeout(() => {
              lottieRef.current.anim.goToAndPlay(0, true);
            }, 1000);
          }
        }
        count += 1
        if (count === 4){count = 0; round += 1;}
      }
      await new Promise(resolve => setTimeout(resolve, (2 * 1000)))
      document.getElementsByClassName('circleCometDiv')[3].style.display = 'none';
      if (props.unit4 || props.unit3){
        document.getElementsByClassName('animateBirdFollow')[0].style.display='block';
        sleep(100).then(() => {
          document.getElementById('tappingBird').style.display='none'
        })
      }
    }

    function increaseCoins() {
      props.module.coins++;
    }

    const coinAnimation = () => {
      setCoinAnimationState("coinAnimation")
    }

    async function ftbTutorial(){
      let count = 0
      if(props.unit3 || props.unit4){
        document.getElementById('tappingBird').style.display='block'
        sleep(100).then(() => {
          document.getElementsByClassName('animateBirdFollow')[0].style.display='none';
        })
      }
      for (let i = 1; i < 9; i++){
        await new Promise(resolve => setTimeout(resolve, ((timing[i].timestamp - timing[i-1].timestamp) * 1000)))
        if(count===0){
          document.getElementsByClassName('circleCometDiv')[3].style.display = 'none';
        }
        else{
          if(count===1){
            context.activateClickDiv = false;
            setContext({ ...context})
          }
          document.getElementsByClassName('circleCometDiv')[count-1].style.display = 'none';
        }
        document.getElementsByClassName('circleCometDiv')[count].style.display = 'block';
        if(count === 0){
          setTimeout(() => {
            context.activateClickDiv = true;
            setContext({ ...context});
          }, 900);
          setTimeout(() => {
            setCounting(false)
          }, 1200);
        }
        else{
          if(props.unit3 || props.unit4) {
            setTimeout(() => {
              lottieRef.current.anim.goToAndPlay(0, true);
            }, 1000);
          }
        }
        count += 1;
        if (count === 4) {
          count = 0;
        }
      }
    }


    // Initially starts FTB with or without the tutorial based on what day we're at
    function controllerStart(){
      if(props.module.unlockedDays.day2 || login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setPlayInstructions(true)
        setAnimalVoice(props.instruction);
        setMonkeyState(props.instructionGIF)
        setShowAnimal(true);
        context.finishedTutorial = true;
        setContext({ ...context});
      }
      else{
        setSong(props.walkthrough)
        context.startedTutorial = true;
        setContext({ ...context })
      }
    }

    async function leftrightHands(){
      if(tutorial !== props.tutorial1_2){
        document.getElementById('rightHand').style.display =
        'none';
      }
      else{
        document.getElementById('leftHand').style.display =
        'none';
      }
      document.getElementsByClassName('circleCometDiv')[1].style.display =
      'block';
      setTimeout(() => {
        lottieRef.current.anim.goToAndPlay(0, true);
      }, 500);
      await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
      document.getElementsByClassName('circleCometDiv')[1].style.display =
      'none';
      document.getElementsByClassName('circleCometDiv')[2].style.display =
      'block';
      setTimeout(() => {
        lottieRef.current.anim.goToAndPlay(0, true);
      }, 500);
      await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
      document.getElementsByClassName('circleCometDiv')[2].style.display =
      'none';
      document.getElementsByClassName('circleCometDiv')[3].style.display =
      'block';
      setTimeout(() => {
        lottieRef.current.anim.goToAndPlay(0, true);
      }, 500);
      await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
      document.getElementsByClassName('circleCometDiv')[3].style.display =
      'none';
      if(tutorial !== props.tutorial1_2){
        setTutorial(props.tutorial1_2)
        context.startedTutorial = true;
        setContext({ ...context });
      }
      else{
        context.startedTutorial2 = true;
        setContext({ ...context });
      }
    }


      // A function that should be removed when the app is deployed, this allows us 
    // as devs to skip the entirity of FTB. 
    function SkipBubbles(){
      setPlaySong(false);
      if(!props.module.reviewIcon){
        dispatch({type: props.stepComplete, payload: "followthebeat"});
      }
      props.setDisplayFTB(false);
    }


    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }



    return (
        <>
        {displayVoice && <audio autoPlay onPlay={()=>{setAudioReady(true)}} onEnded={() => {
            setAudioReady(false); 
            setDisplayVoice(false);
            setShowAnimal(false);
            if(playInstructions){
              setPlayInstructions(false);  
              setPlaySong(true);}
            if(playAwesomeJob){
              updateScore();
              if(!props.module.reviewIcon){
                dispatch({type: props.stepComplete, payload: "followthebeat"});
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayFTB(false)
            }
          }
        }> 
            <source src={animalVoice}></source>
        </audio>}

        <div id="FollowTheBeatBody10" style={{backgroundImage: `url(${generateImageUrl('images/Module10Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+6.png')})`}}>
            {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false ) && <button type='button' onClick={SkipBubbles}>
              Skip The Bubbles
            </button>}
            {isOpen && <PopUp
                content={<>
                    <b id='title'>Ready to begin playing?<br/></b>
                    <button id='logoutButton1' className='logoutButton' 
                    onClick={() => {
                      setCounting(false);
                      togglePopup();
                      setSong(props.song);
                      setPlaySong(true);
                      context.finishedTutorial = true;
                      setContext({ ...context });
                      }}>START</button>
                </>
                }
                handleClose={togglePopup}
            />}

            <div className='scoreBar'>
                <img className="scoreKey" src={coinBar} alt="bird Icon" />
                {props.module.coins < 10 && <h5 className='scoretext1' >{props.module.coins}</h5>}
                {props.module.coins >= 10  && props.module.coins < 100 && <h5 className='scoretext10' >{props.module.coins}</h5>}
                {props.module.coins >= 100 && <h5 className='scoretext100' >{props.module.coins}</h5>}
                <p className='scoretext' >100</p>
            </div>

            {showCoin && <img id={coinAnimationState} className='chooseReward' src={coin} alt="reward key" style={{position: 'absolute', top: '40vh', left: '50vw', width: '100px', height: '100px', marginLeft: '-50px', marginTop: '-50px'}} onClick={() => { coinAnimation() }}></img>}

            <img className='back-btn-ftb' src={Exit} onClick={() => {
                           props.setDisplayFTB(false)  
                        }}>
            </img>

            {(props.unit3 || props.unit4) && <div className='lottieBird' id='tappingBird' style={{display: 'none'}}>
              <LottieAnimation
                ref={lottieRef}
                jsonUrl="appfiles/active_listening/animation_bird_tapping.json"
                onAnimationComplete={() => console.log('completed')}
                unit1={true}
                login={login}

              />
            </div>}
            
            <img className="animateBirdFollow" src={bird} alt="bird Icon"/>
            {showAnimal && !audioReady && <img id="loading"  src={loading}/>}
            {showAnimal && <img className="animateBirdFollow"  style={(audioReady) ? {} : { display: 'none' }} src={monkeyStatemonkeyState} onLoad={()=>{setDisplayVoice(true)}} onError={()=>(setShowAnimal(false))}/>}
            {!isOpen && <img className="animateBirdFollow" src={CountingGif} style={counting ? { display: "block" } : { display: "none" }}/>}
            <img className="animateAlien" src={alien} alt="alien Icon"/>

            <div id="clickCircle"/>
              <div className="particle"> 
              </div>
            <img src={left} id='leftHand' alt='left hand'/>
            <img src={right} id='rightHand' alt='right hand'/>
            {context.activateClickDiv ? <div id="timedCircle" onClick={function(){
                if (context.finishedTutorial) {setScore(score + 1);}
                if(context.finishedTutorial || context.startedTutorial2){
                  setCoinAnimationState('coinAnimation');
                  setShowCoin(true);
                  sleep(1000).then(() => {
                    setShowCoin(false);
                    increaseCoins();
                    setCoinAnimationState("")
                  })
                }
                else{
                  context.activateClickDiv = false;
                  if (props.unit4){
                    document.getElementById('tappingBird').style.display='block'
                    sleep(100).then(() => {
                      document.getElementsByClassName('animateBirdFollow')[0].style.display='none';
                    })
                    leftrightHands();
                  }
                  else{
                    context.startedTutorial2 = true;
                  }
                  document.getElementsByClassName('circleCometDiv')[0].style.display = 'none'
                  setContext({ ...context});
                }
                context.activateClickDiv = false;
                setContext({ ...context});
            }} role='button'></div>:<></>}
            <div id="circleComet1" class="circleCometDiv" style={{backgroundImage: `url(${generateImageUrl('images/Module10Images/Unit2_Mod5_FTB_GoldComet.svg')})`}}><p class="cometText">1</p></div>
            <div id="circleComet2" class="circleCometDiv" style={{backgroundImage: `url(${generateImageUrl('images/Module10Images/Unit2_Mod5_FTB_BlueComet.svg')})`}}><p class="cometText">2</p></div>
            <div id="circleComet3" class="circleCometDiv" style={{backgroundImage: `url(${generateImageUrl('images/Module10Images/Unit2_Mod5_FTB_BlueComet.svg')})`}}><p class="cometText">3</p></div>
            <div id="circleComet4" class="circleCometDiv" style={{backgroundImage: `url(${generateImageUrl('images/Module10Images/Unit2_Mod5_FTB_BlueComet.svg')})`}}><p class="cometText">4</p></div>
        </div>
        <audio
          ref={musicAudioRef}
          src={musicSrc}
          preload='auto'
          playsInline
          onLoadedData={() => {
            const el = musicAudioRef.current;
            if (!el) return;
            if (!musicShouldPlay) return;
            el.currentTime = 0;
            el.play().then(() => {
              const onPlayAction = musicOnPlayActionRef.current;
              if (typeof onPlayAction === 'function') onPlayAction();
            }).catch(() => {});
          }}
          onEnded={() => {
            const action = musicEndActionRef.current;
            musicEndActionRef.current = null;
            setMusicShouldPlay(false);
            if (typeof action === 'function') action();
          }}
        />
        </>
    );
}
export default FollowTheBeatModule10;

